import { render, staticRenderFns } from "./SendAuto.vue?vue&type=template&id=639ef584&"
import script from "./SendAuto.vue?vue&type=script&lang=js&"
export * from "./SendAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports